import * as types from '../types.js';

export default {

	html: `
		<style>
			#log #id		{ width: 6rem; text-align: right;	}
			#log #date_time	{ width: 10rem;	}
			#log #user_id	{ width: 12rem;	}
			#log #origin	{ width: 6rem;	}
			#log #method	{ width: 5rem;	}
			#log .agent		{ width: 100%;	}
			#log .path		{ width: 100%;	}
			#log .body		{ width: 100%;	}
		</style>
		<form id="log" class="form" autocomplete="off">
			<datalist id="users">
			</datalist>
			<div class="fsb">
				<label title="Identificador do evento">Evento
					<input id="id" type="text" disabled>
				</label>
				<label title="Data e hora do registro">Data/Hora
					<input id="date_time" type="text" disabled>
				</label>
				<label title="Usuário">Usuário
					<input id="user_id" type="text" list="users" disabled>
				</label>
				<label title="Endereço IP de Origem">Origem
					<input id="origin" type="text" disabled>
				</label>
				<label title="Método HTTP">Método
					<input id="method" type="text" disabled>
				</label>
			</div>
			<div>
				<label class="agent" title="User-Agent">Agente
					<input id="agent" type="text" disabled>
				</label>
			</div>
			<div>
				<label class="path" title="Caminho">URL
					<input id="path" type="text" disabled>
				</label>
			</div>
			<div>
				<label class="body" title="Corpo da requisição">Dados
					<textarea id="body" rows="8" disabled></textarea>
				</label>
			</div>
			<div class="tar">
				<button class='bn_Escape button'>Fechar</button>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#log',
		init(formset)	// Must not be async as init seq must be preserved
		{
			formset.loadList('#users', 'users');
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	
	fields: [
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#date_time' }, types: [types.datetime()] },
		{ properties: { selector: '#user_id' }, types: [types.datalist()] },
		{ properties: { selector: '#origin' }, types: [] },
		{ properties: { selector: '#agent' }, types: [] },
		{ properties: { selector: '#method' }, types: [] },
		{ properties: { selector: '#path' }, types: [] },
		{ properties: { selector: '#body' }, types: [types.textarea()] }
	]

};

